module.exports = __webpack_public_path__ + "static/media/address.f602e726.svg";